import type { State } from '../../types';
import type { DocumentViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function documentsNotDeleted(state: State): DocumentViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.documentsById).filter((e) => !e.deleted);
}
